<template>
<span>
    <v-toolbar flat color="white">
        <v-toolbar-title class="lime--text lighten-1">Gerenciar Administradores</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <template>
            <v-btn color="grey darken-2" dark class="mb-1" @click.prevent="atualizaDados">
                <v-icon dark>sync</v-icon>Atualizar
            </v-btn>
            <v-btn color="success" dark class="mb-1 ml-2" :to="{name: 'user.add'}">
                <v-icon class="mdi mdi-plus"></v-icon>Adicionar Novo Usuário
            </v-btn>
        </template>
    </v-toolbar>

    <v-card>
        <v-card-title>
            <v-text-field v-model="search" append-icon="search" label="Localizar" outlined></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="loadUsers" :search="search" :rowsPerPageItems="rowsPerPageItems">

            <template v-slot:[`item.usu_foto`]="{ item }">
                <td width="15%" v-if="item.usu_foto"><img :src="`${base_url}upload/user/${item.usu_foto}?${uuid}`" class="avatar"></td>
                <td width="15%" v-if="!item.usu_foto"><img :src="`${base_url}upload/avatar.png`" class="avatar"></td>
            </template>

            <template v-slot:[`item.usu_celular`]="{ item }">
                <td>
                    <span color="lime">{{ item.usu_celular }}</span>
                </td>
            </template>

            <template v-slot:[`item.usu_admin`]="{ item }">
                <td>
                    <v-switch color="lime" v-model="item.usu_admin" @change="onChangeUsuAdminEventHandler(item.usu_id, $event)" class="my-switch"></v-switch>
                </td>
            </template>

            <template v-slot:[`item.usu_funcionario`]="{ item }">
                <td>
                    <v-switch color="lime" v-model="item.usu_funcionario" @change="onChangeUsuFuncEventHandler(item.usu_id, $event)" class="my-switch"></v-switch>
                </td>
            </template>

            <template v-slot:[`item.usu_usuario`]="{ item }">
                <td>
                    <v-switch color="lime" v-model="item.usu_usuario" @change="onChangeUsuUsuarioEventHandler(item.usu_id, $event)" class="my-switch"></v-switch>
                </td>
            </template>

            <template v-slot:[`item.usu_status`]="{ item }">
                <td>
                    <v-switch color="lime" v-model="item.usu_status" @change="onChangeStatusEventHandler(item.usu_id, $event)" class="my-switch"></v-switch>
                </td>
            </template>

            <template v-slot:[`item.acoes`]="{ item }">
                <v-tooltip top color="blue white--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="blue lighten-1" @click.prevent="editUser(item)" v-on="on">
                            <v-icon dark>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>Editar</span>
                </v-tooltip>

                <v-tooltip top color="lime black--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="lime lighten-1" @click.prevent="detailUser(item)" v-on="on">
                            <v-icon dark class="mdi mdi-view-headline"></v-icon>
                        </v-btn>
                    </template>
                    <span>Detalhes</span>
                </v-tooltip>

                <v-tooltip top color="red black--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="red lighten-1" @click.prevent="deleteUser(item)" v-on="on">
                            <v-icon dark class="mdi mdi-delete-outline"></v-icon>
                        </v-btn>
                    </template>
                    <span>Excluir</span>
                </v-tooltip>

                <v-tooltip top color="green white--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="green lighten-1" @click.prevent="ordersUser(item)" v-on="on">
                            <v-icon dark class="mdi mdi-cart"></v-icon>
                        </v-btn>
                    </template>
                    <span>Mostrar Pedidos</span>
                </v-tooltip>

            </template>

            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">Voce procurou por "{{ search }}" nenhum item localizado.</v-alert>
            </template>
        </v-data-table>
    </v-card>
</span>
</template>

<script>
import {
    uuid
} from "vue-uuid";
import {
    URL_BASE
} from "../../../config/configs";

export default {
    name: "UserAdminComponent",

    created() {
        this.$store.dispatch("loadUsersAdmin");
    },
    computed: {
        loadUsers() {
            if (this.$store.state.users.items.data == null) return [];

            return this.$store.state.users.items.data;
        }
    },
    data() {
        return {
            search: "",
            rowsPerPageItems: [
                10,
                20,
                30,
                {
                    text: "$vuetify.dataIterator.rowsPerPageAll",
                    "10": -1
                }
            ],
            headers: [{
                    sortable: false,
                    text: "Foto",
                    value: "usu_foto"
                },
                {
                    sortable: false,
                    text: "Nome",
                    value: "usu_nome"
                },
                {
                    sortable: false,
                    text: "Email",
                    value: "email"
                },
                {
                    sortable: false,
                    text: "Telefone",
                    value: "usu_celular"
                },
                {
                    sortable: false,
                    text: "Admin",
                    value: "usu_admin"
                },
                {
                    sortable: false,
                    text: "Funcionário",
                    value: "usu_funcionario"
                },
                {
                    sortable: false,
                    text: "Cliente",
                    value: "usu_usuario"
                },
                {
                    sortable: false,
                    text: "Status",
                    value: "usu_status"
                },
                {
                    text: "Ações",
                    align: "center",
                    sortable: false,
                    value: "acoes"
                }
            ],
            user: [{
                usu_id: "1",
                email: "",
                usu_tipo: "",
                usu_nome: "",
                usu_cpf: "",
                usu_rg: "",
                usu_cnpj: "",
                usu_ie: "",
                usu_prefixo: "",
                usu_fone1: "",
                usu_fone2: "",
                usu_celular: "",
                usu_status: false
            }],
            base_url: URL_BASE,
            uuid: uuid.v1()
        };
    },
    methods: {
        atualizaDados() {
            this.$store.dispatch("loadUsersAdmin");
        },
        editUser(item) {
            this.$router.push({
                name: "user.edit",
                params: {
                    usu_id: item.usu_id
                }
            });
        },
        detailUser(item) {
            this.$router.push({
                name: "user.detail",
                params: {
                    usu_id: item.usu_id
                }
            });
        },
        deleteUser(item) {
            this.$swal({
                title: 'Você tem certeza?',
                text: "Você não poderá reverter isso",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#D32F2F',
                cancelButtonColor: '#1976D2',
                confirmButtonText: 'Sim, Exclua!'
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch('destroyUser', item.usu_id)
                        .then(response => {
                            if (response.data.success) {
                                this.$swal({
                                    position: "center",
                                    icon: "success",
                                    title: 'Sucesso',
                                    text: 'Usuário excluído com sucesso',
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                                this.atualizaDados();
                            } else {
                                this.$swal({
                                    position: "center",
                                    icon: "warning",
                                    title: 'Atenção!',
                                    text: response.data.message,
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                            }
                        })
                        .catch(error => {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: 'Opssss!',
                                text: error.data.message,
                                showConfirmButton: true,
                                timer: 6000
                            });
                        })
                }
            })
        },
        ordersUser(item) {
            this.$router.push({
                name: "user.orders",
                params: {
                    usu_id: item.usu_id
                }
            });
        },

        onChangeStatusEventHandler(usu_id, value) {
            this.$store
                .dispatch("updateStatusUser", {
                    usu_id: usu_id,
                    usu_status: value
                })
                .then(() => {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: "Sucesso",
                        text: "Status do Popup atualizado com sucesso",
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Opssss!",
                        text: "Erro ao atualizar status do Popup",
                        showConfirmButton: true,
                        timer: 6000
                    });
                });
        },
        onChangeUsuAdminEventHandler(usu_id, value) {
            this.$store
                .dispatch("updateAdminUser", {
                    usu_id: usu_id,
                    usu_admin: value
                })
                .then(() => {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: "Sucesso",
                        text: "Status Admin atualizado com sucesso",
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Opssss!",
                        text: "Erro ao atualizar status para Admin",
                        showConfirmButton: true,
                        timer: 6000
                    });
                });
        },
        onChangeFuncEventHandler(usu_id, value) {
            this.$store
                .dispatch("updateFuncUser", {
                    usu_id: usu_id,
                    usu_func: value
                })
                .then(() => {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: "Sucesso",
                        text: "Status Funcionário atualizado com sucesso",
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Opssss!",
                        text: "Erro ao atualizar status para Funcionário",
                        showConfirmButton: true,
                        timer: 6000
                    });
                });
        },
        onChangeUsuUsuarioEventHandler(usu_id, value) {
            this.$store
                .dispatch("updateClienteUser", {
                    usu_id: usu_id,
                    usu_usuario: value
                })
                .then(() => {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: "Sucesso",
                        text: "Status Cliente atualizado com sucesso",
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Opssss!",
                        text: "Erro ao atualizar status para Cliente",
                        showConfirmButton: true,
                        timer: 6000
                    });
                });
        },
        onChangeUsuFuncEventHandler(usu_id, value) {
            this.$store
                .dispatch("updateFuncUser", {
                    usu_id: usu_id,
                    usu_usuario: value
                })
                .then(() => {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: "Sucesso",
                        text: "Funcionário atualizado com sucesso",
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Opssss!",
                        text: "Erro ao atualizar Funcionário",
                        showConfirmButton: true,
                        timer: 6000
                    });
                });
        }
    }
};
</script>

<style scoped>
.avatar {
    height: 40px;
    margin-top: 0.4rem;
}
</style>
